/* eslint-disable react/react-in-jsx-scope */
import { useEntity } from '@backstage/plugin-catalog-react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { useState } from 'react';
import type { JiraIssue } from '../api/JiraApi';
import { useJiraAnnotations } from '../hooks/useJiraAnnotations';
import { useJiraIssues } from '../hooks/useJiraIssues';
import { AgentTaskCard } from './AgentTaskCard';
import { JiraIssuesTable } from './JiraIssuesTable';

export function EntityJiraContent() {
  const { entity } = useEntity();
  const annotations = useJiraAnnotations(entity);
  const { issues, loading, error } = useJiraIssues(annotations);
  const [selected, setSelected] = useState<JiraIssue[]>([]);
  const [tableRemountKey, setTableRemountKey] = useState(0);

  const handleClearSelections = () => {
    setSelected([]);
    setTableRemountKey(k => k + 1);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="flex-start"
          style={{ gap: 24 }}
        >
          <Box flex="1 1 480px" minWidth={0} maxWidth="100%">
            <JiraIssuesTable
              issues={issues}
              loading={loading}
              error={error}
              onSelectionChange={setSelected}
              tableRemountKey={tableRemountKey}
              selectedCount={selected.length}
              onClearSelections={handleClearSelections}
            />
          </Box>
          <Box flex="0 0 auto" width={360} maxWidth="100%">
            <AgentTaskCard entity={entity} selectedIssues={selected} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
